/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { VehiclesFilters } from '@types'

type ContextState = {
  filters: VehiclesFilters
  setFilters: Dispatch<SetStateAction<VehiclesFilters>>
  isVehiclesSync: boolean
  setIsVehiclesSync: Dispatch<SetStateAction<boolean>>
  resetFilters: () => void
  resetTriggered: number
}

export const initialVehiclesFiltersState: ContextState = {
  filters: { page: 1, limit: 10, orderBy: 'ASC' },
  setFilters: () => {},
  isVehiclesSync: false,
  setIsVehiclesSync: () => {},
  resetFilters: () => {},
  resetTriggered: 0,
}

const VehiclesContext = React.createContext<ContextState>(initialVehiclesFiltersState)

type VehiclesFiltersProviderProps = {
  children: React.ReactNode
}

export function VehiclesFiltersProvider({ children }: VehiclesFiltersProviderProps) {
  const [isVehiclesSync, setIsVehiclesSync] = useState<boolean>(false)
  const [filters, setFilters] = useState<VehiclesFilters>(initialVehiclesFiltersState.filters)
  const [resetTriggered, setResetTriggered] = useState<number>(0)
  const [search] = useSearchParams()
  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters(initialVehiclesFiltersState.filters)
    }
  }, [resetTriggered])

  useEffect(() => {
    if (filters && search.get('service') && !filters.asnum) {
      const timeout = setTimeout(
        () =>
          setFilters(state => ({
            ...state,
            asnum: Number(search.get('service')) ?? undefined,
            page: initialVehiclesFiltersState.filters.page,
          })),
        0,
      )

      return () => clearTimeout(timeout)
    } else {
      setFilters(initialVehiclesFiltersState.filters)
    }
  }, [search])

  return (
    <VehiclesContext.Provider
      value={{
        filters,
        setFilters,
        isVehiclesSync,
        setIsVehiclesSync,
        resetFilters,
        resetTriggered,
      }}
    >
      {children}
    </VehiclesContext.Provider>
  )
}

export function useVehiclesContext(): ContextState {
  const context = useContext(VehiclesContext)
  if (!context) throw Error('This hook can only be used under the VehicleFiltersProvider component')
  return context
}
